import API from './Api';
import ApiUrls from '../config/ApiUrls';
import { replaceByObject } from '../utils/Urls';
import { AxiosResponse } from 'axios';
import { AppHost } from '../config/Config';

export enum UserPermission {
  owner = 'owner',
  readwrite = 'readwrite',
  read = 'read',
}

export const UserPermissionHierarchy = [
  UserPermission.read,
  UserPermission.readwrite,
  UserPermission.owner,
];

export type UserApiResponse = {
  id: number;
  email: string;
  forename: string;
  surname: string;
  username: string;
  groups: { id: number }[];
  hash: string;
  externalId: string;
  acceptedDocs: string;
  type: string;
};

export type UserGroupApiResponse = {
  permissions: UserPermission;
  group: number;
};

type TokenResponse = {
  access: string;
};

export class UserApi extends API {
  static getUser(userId: number): Promise<UserApiResponse> {
    return API.get(replaceByObject(ApiUrls.User, { userId }), {}).then(
      (response: AxiosResponse<UserApiResponse>) => response.data
    );
  }

  static getGroups(userId: number): Promise<UserGroupApiResponse[]> {
    return API.get(replaceByObject(ApiUrls.UserGroups, { userId })).then(
      (response: AxiosResponse<UserGroupApiResponse[]>) => response.data
    );
  }

  static acceptDocs(userId: number): Promise<UserApiResponse> {
    return API.post(
      replaceByObject(ApiUrls.UserAcceptDocs, { userId }),
      {}
    ).then((response: AxiosResponse<UserApiResponse>) => response.data);
  }

  static login(provider: string): Promise<string> {
    let callback = `${AppHost}/login/complete`;
    if (provider != 'xero') callback += `/${provider}`;
    return API.post(
      replaceByObject(ApiUrls.LoginStart, { provider }),
      {},
      {
        params: {
          callback: callback,
        },
      }
    ).then((response: AxiosResponse<string>) => response.data);
  }

  static complete(provider: string, params: object): Promise<TokenResponse> {
    return API.put(
      replaceByObject(ApiUrls.LoginEnd, { provider }),
      params
    ).then((response: AxiosResponse<TokenResponse>) => response.data);
  }
}
